var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10814 0.773233C8.48371 0.4636 9.4815 1.64584 9.4815 2.81474V13.1852C9.4815 14.3541 8.48371 15.5364 7.10814 15.2267C3.80291 14.483 1.33325 11.5304 1.33325 7.99999C1.33325 4.46957 3.80291 1.51695 7.10814 0.773233ZM11.18 5.25403C11.3189 5.11516 11.5073 5.03715 11.7037 5.03715C11.9002 5.03715 12.0885 5.11516 12.2275 5.25403L14.4497 7.47628C14.5886 7.61519 14.6666 7.80357 14.6666 7.99999C14.6666 8.19641 14.5886 8.38478 14.4497 8.5237L12.2275 10.7459C12.0877 10.8809 11.9006 10.9555 11.7064 10.9539C11.5122 10.9522 11.3264 10.8743 11.1891 10.7369C11.0517 10.5996 10.9738 10.4138 10.9721 10.2196C10.9704 10.0253 11.0451 9.83823 11.18 9.69852L12.1378 8.74074H5.77775C5.58129 8.74074 5.39288 8.66269 5.25396 8.52377C5.11504 8.38486 5.037 8.19644 5.037 7.99999C5.037 7.80353 5.11504 7.61511 5.25396 7.4762C5.39288 7.33728 5.58129 7.25924 5.77775 7.25924H12.1378L11.18 6.30145C11.0412 6.16254 10.9632 5.97416 10.9632 5.77774C10.9632 5.58132 11.0412 5.39294 11.18 5.25403Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic-logout.91c3f1ae088f336533be111699ac97ef.svg";
export { ForwardRef as ReactComponent };